module.exports = __webpack_public_path__ + "static/img/TransferRechargebg.3e21b2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/TransferRechargebg.png
// module id = KYk4
// module chunks = 0